import React, { HTMLAttributes } from 'react';
import * as S from './Divider.styled';

export interface DividerProps extends HTMLAttributes<HTMLDivElement> {
  direction?: 'horizontal' | 'vertical';
  margin?: number;
  marginTop?: number;
  marginBottom?: number;
  thickness?: number;
}

const Divider = React.forwardRef<HTMLDivElement, DividerProps>(
  (
    {
      direction,
      margin,
      marginTop,
      marginBottom,
      thickness,
      ...props
    }: DividerProps,
    forwardedRef,
  ) => {
    return (
      <S.Container direction={direction}>
        <S.Divider
          ref={forwardedRef}
          direction={direction}
          margin={margin}
          marginTop={marginTop}
          marginBottom={marginBottom}
          thickness={thickness}
          {...props}
        />
      </S.Container>
    );
  },
);

export default Divider;
